<script type="text/ecmascript-6">
    import RadioQuestion from "../mixin/RadioQuestion.vue";
    import SynsealRadioQuestion from "../mixin/synseal/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion,
            SynsealRadioQuestion,
        ],
        props: {
            title: {
                default(){
                    return 'Alu Lock Strip:';
                }
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/yes-no';
            },
            cache_key(){
                return '_';
            },
        },
    }
</script>
